var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1162_9489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.4603V21.1203H27.2551C26.8487 23.2621 25.6292 25.0757 23.8 26.2951L29.3813 30.6257C32.6331 27.6241 34.5091 23.2153 34.5091 17.978C34.5091 16.7586 34.3997 15.586 34.1964 14.4605L18 14.4603Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36095 20.8602L7.10217 21.8238L2.64648 25.2944C5.47618 30.9069 11.2759 34.7841 17.9983 34.7841C22.6414 34.7841 26.5342 33.252 29.3796 30.6256L23.7984 26.295C22.2663 27.3268 20.312 27.9522 17.9983 27.9522C13.5271 27.9522 9.72821 24.935 8.36798 20.8701L8.36095 20.8602Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64738 9.8797C1.47491 12.1934 0.802734 14.8043 0.802734 17.587C0.802734 20.3698 1.47491 22.9807 2.64738 25.2944C2.64738 25.3099 8.36943 20.8544 8.36943 20.8544C8.02549 19.8226 7.82219 18.7283 7.82219 17.5868C7.82219 16.4454 8.02549 15.3511 8.36943 14.3193L2.64738 9.8797Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9987 7.23724C20.5314 7.23724 22.7826 8.1127 24.5805 9.80117L29.5051 4.8766C26.519 2.09385 22.642 0.389664 17.9987 0.389664C11.2762 0.389664 5.47618 4.25119 2.64648 9.87935L8.36835 14.3193C9.72841 10.2545 13.5275 7.23724 17.9987 7.23724Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1162_9489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3942,
    height: 34.3942,
    fill: "white",
    transform: "translate(0.802734 0.389664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.df39250fb0d497019c7e8e2852920e7a.svg";
export { ForwardRef as ReactComponent };